import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";

import AppContext from "../appContext";
import { stringToHslColor } from "../tools";
import useAccountSettings from "../ManageAccount/useAccountSettings";
import { Box } from "@mui/material";

function Alias({ size }) {
  const { t } = useTranslation();
  const {
    app: {
      client: { id, alias, initials, isExample },
    },
  } = useContext(AppContext);
  const {
    accountSettings: { testDeviceConnectionId },
  } = useAccountSettings();

  const avatarStyle = (function () {
    const defaultAvatarStyle = {
      backgroundColor: stringToHslColor(alias),
      color: "#fff",
    };
    const customAvatarStyle =
      size === "small"
        ? {
            fontSize: 16,
            width: "40px",
            height: "40px",
          }
        : {
            width: "56px",
            height: "56px",
          };
    return { ...defaultAvatarStyle, ...customAvatarStyle };
  })();

  return (
    <Box
      display={"flex"}
      alignItems="center"
      flex={1}
      whiteSpace="nowrap"
      overflow="hidden"
      textOverflow={"ellipsis"}
    >
      <Avatar sx={avatarStyle}>{initials}</Avatar>
      <Box paddingLeft={size === "small" ? 1 : 2}>
        <Typography variant={"h6"} noWrap>
          {alias}
        </Typography>
        {testDeviceConnectionId === id ? (
          <Typography variant="body2" color="textSecondary">
            {t("navigation.clients.me")}
          </Typography>
        ) : null}
        {isExample === 1 ? (
          <Typography variant="body2" color="textSecondary">
            {t("navigation.clients.dummy")}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
}

export default Alias;
